(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  /* ────────────────────────────
     Section reveal: DISABLED.
     The fade-up reveal started sections at opacity:0 and faded them
     in when they entered the viewport. That made the fixed hero
     bleed through transparent sections during the fade window. We
     disable it here (and also force opacity:1 in the CSS) so sections
     just appear when scrolled into view — same as any other page.

     Same applies to the per-card entrance animation that used to run
     inside featured-grid — removed for the same reason.
     ──────────────────────────── */

  /* ────────────────────────────
     Scroll story: slide swap + progress bar + counter
     ──────────────────────────── */
  function initScrollStory() {
    if (isMobile || !('IntersectionObserver' in window)) return;

    var storyEl = document.querySelector('[data-scroll-story]');
    if (!storyEl) return;

    var slides = storyEl.querySelectorAll('.dd-story__slide');
    var cards = storyEl.querySelectorAll('.dd-story__card[data-story-index]');
    var counterEl = storyEl.querySelector('[data-counter-current]');
    var progressEl = storyEl.querySelector('[data-progress-fill]');
    var cardsContainer = storyEl.querySelector('.dd-story__cards');

    if (!slides.length || !cards.length) return;

    var activeIndex = 0;
    var totalSlides = slides.length;

    function setActiveSlide(idx) {
      if (idx === activeIndex) return;
      slides[activeIndex].classList.remove('is-active');
      activeIndex = idx;
      slides[idx].classList.add('is-active');

      if (counterEl) {
        counterEl.textContent = (idx < 9 ? '0' : '') + (idx + 1);
      }
    }

    var visibleCards = {};

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = entry.target.getAttribute('data-story-index');
        if (entry.isIntersecting) {
          visibleCards[idx] = entry.intersectionRatio;
        } else {
          delete visibleCards[idx];
        }
      });

      var bestIdx = null;
      var bestRatio = 0;
      for (var k in visibleCards) {
        if (visibleCards[k] > bestRatio) {
          bestRatio = visibleCards[k];
          bestIdx = k;
        }
      }
      if (bestIdx !== null) {
        var n = parseInt(bestIdx, 10);
        if (!isNaN(n) && n >= 0 && n < totalSlides) {
          setActiveSlide(n);
        }
      }
    }, { threshold: [0.15, 0.35, 0.55, 0.75], rootMargin: '0px 0px -15% 0px' });

    cards.forEach(function (card) { obs.observe(card); });

    if (progressEl && cardsContainer) {
      var ticking = false;

      function updateProgress() {
        var rect = cardsContainer.getBoundingClientRect();
        var vh = window.innerHeight;
        var scrollStart = -rect.top;
        var scrollRange = rect.height - vh;
        if (scrollRange <= 0) {
          progressEl.style.width = '100%';
        } else {
          var pct = Math.max(0, Math.min(1, scrollStart / scrollRange));
          progressEl.style.width = (pct * 100).toFixed(1) + '%';
        }
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(updateProgress);
          ticking = true;
        }
      }, { passive: true });

      updateProgress();
    }
  }

  /* ────────────────────────────
     Card entrance animation: DISABLED.
     Same rationale as initReveal — story cards starting at opacity:0
     let the fixed hero bleed through the featured-grid section during
     their fade window. Cards now render immediately.
     ──────────────────────────── */

  /* ────────────────────────────
     Hero pin: the hero is `position: fixed` so it stays pinned to the
     top of the viewport while content sections scroll over it. Once
     the hero's section wrapper has scrolled fully past the top of the
     viewport, we flip `body.dd-past-hero` so CSS can hide the fixed
     hero — otherwise it would continue to paint at viewport-top
     forever, bleeding through transparent lazy-reveal windows or
     showing through above the footer.

     Why a scroll listener instead of IntersectionObserver: IO callbacks
     fire asynchronously (often one frame late) and in our case the
     callback wasn't consistently firing at the boundary. A scroll
     listener runs on every scroll tick and checks the current layout
     directly via getBoundingClientRect, so the class flip is perfectly
     synchronized with scroll position.

     rAF-throttled so we never do more than one layout read per frame,
     and `{ passive: true }` so we don't block scrolling.
     ──────────────────────────── */
  function initHeroVisibility() {
    if (!document.body.classList.contains('template-index')) return;

    /* Shopify namespaces section IDs as
       `shopify-section-template--<id>__<section-name>`, so a starts-with
       match on `shopify-section-dd-hero` never fits. Match on the
       canonical `dd-hero-section` class the hero section applies,
       which is stable and unique to the primary hero (the trust-bar
       section uses its own `dd-hero-trust-section` class). */
    var wrapper = document.querySelector(
      '.shopify-section.dd-hero-section'
    );
    if (!wrapper) return;

    var ticking = false;
    var pastHero = false;
    /* Hysteresis around the rect.bottom == 0 boundary. Without it,
       subpixel scroll positions, rubber-band momentum, and Chromium's
       pixel-snap behavior at the very top of the page can cause
       rect.bottom to oscillate across 0 between consecutive frames,
       chattering the body class and triggering paint-tree work each
       time. 8px is large enough to absorb that noise and small enough
       to be imperceptible at the boundary (the hero is already fully
       occluded by the next opaque section by the time we get here). */
    var DEADBAND = 8;

    function check() {
      var rect = wrapper.getBoundingClientRect();
      /* rect.bottom is the y-coord of the wrapper's bottom edge in
         viewport space. When it's <= 0, the entire wrapper is above
         the viewport — i.e., user has scrolled past the hero. With
         hysteresis: stay past unless we're clearly NOT past anymore
         (bottom > +DEADBAND); only become past when we're clearly
         past (bottom < -DEADBAND). */
      var nowPast = pastHero ? rect.bottom <= DEADBAND : rect.bottom < -DEADBAND;
      if (nowPast !== pastHero) {
        pastHero = nowPast;
        document.body.classList.toggle('dd-past-hero', pastHero);
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(check);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  /* ────────────────────────────
     Init
     ──────────────────────────── */
  function init() {
    initHeroVisibility();
    initScrollStory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
